import { Controller } from "@hotwired/stimulus"

// Syncs default IMAP port when encryption mode changes.
export default class extends Controller {
  static targets = ["encryption", "port", "noneWarning"]

  static defaults = {
    ssl: 993,
    starttls: 143,
    none: 143
  }

  connect() {
    this.syncPort()
  }

  syncPort() {
    if (!this.hasEncryptionTarget || !this.hasPortTarget) return

    const mode = this.encryptionTarget.value
    const defaultPort = this.constructor.defaults[mode]
    if (defaultPort) this.portTarget.value = defaultPort

    if (this.hasNoneWarningTarget) {
      this.noneWarningTarget.classList.toggle("d-none", mode !== "none")
    }
  }
}
